import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppRouter from './Routes/AppRouter';
import AxiosProvider from './components/AxiosProvider';
import { NotificationStack } from './components/Notifications/NotificationStack';
import { NotificationFetcher } from './components/Notifications/NotificationsFetcher';
import { NotificationProvider } from './components/Notifications/NotificationsProvider';
import store from './store';
import { MAIN_THEME } from './theme';

function App() {
  LicenseInfo.setLicenseKey(
    '56f7170996a6417d9bda2259af6adb9cTz0xMjIyODUsRT0xNzk4NTg4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=',
  );

  return (
    <ThemeProvider theme={MAIN_THEME}>
      <Provider store={store}>
        <AxiosProvider />
        <NotificationProvider>
          <ToastContainer />
          <NotificationFetcher />
          <NotificationStack />
          <AppRouter />
        </NotificationProvider>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
